window.addEventListener("load", () => {
  const page = document.querySelector("#kich-hoat-bao-hanh");
  if (!page) return;

  const uploadArea = document.querySelector("#upload-area");
  const billFileInput = document.querySelector("#bill-file");

  if (uploadArea && billFileInput) {
    uploadArea.addEventListener("dragover", (e) => {
      e.preventDefault();
      uploadArea.classList.add("bh-upload-area--dragover");
    });
    uploadArea.addEventListener("dragleave", () => {
      uploadArea.classList.remove("bh-upload-area--dragover");
    });
    uploadArea.addEventListener("drop", (e) => {
      e.preventDefault();
      uploadArea.classList.remove("bh-upload-area--dragover");
      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith("image/")) {
        billFileInput.files = e.dataTransfer.files;
        handleBillUpload(billFileInput);
      }
    });
  }

  for (const id of ["fullname", "phone", "ma_don_hang"]) {
    const input = document.querySelector(`#${id}`);
    if (input) {
      input.addEventListener("input", () => clearFieldError(id));
    }
  }

  page.classList.add("bh-visible");
});

/* --- Inline Validation --- */

const VALID_PHONE_PREFIXES = [
  "086","087","096","097","098","032","033","034","035","036","037","038","039",
  "089","090","093","070","079","077","076","078","088","091","094",
  "083","084","085","081","082","092","052","056","058","099","059",
];

function showFieldError(fieldId, message) {
  const input = document.querySelector(`#${fieldId}`);
  const errorEl = document.querySelector(`#error-${fieldId}`);
  if (input) {
    input.classList.add("bh-field__input--error");
  }
  if (errorEl) {
    errorEl.textContent = message;
    errorEl.classList.add("bh-field__error--visible");
  }
}

function clearFieldError(fieldId) {
  const input = document.querySelector(`#${fieldId}`);
  const errorEl = document.querySelector(`#error-${fieldId}`);
  if (input) {
    input.classList.remove("bh-field__input--error");
  }
  if (errorEl) {
    errorEl.textContent = "";
    errorEl.classList.remove("bh-field__error--visible");
  }
}

function clearAllFieldErrors() {
  for (const id of ["fullname", "phone", "ma_don_hang"]) {
    clearFieldError(id);
  }
}

function validateForm() {
  clearAllFieldErrors();
  const fullname = document.querySelector("#fullname").value.trim();
  const phone = document.querySelector("#phone").value.trim();
  const maDonHang = document.querySelector("#ma_don_hang").value.trim();
  let valid = true;

  if (!fullname) {
    showFieldError("fullname", "Vui lòng nhập họ và tên");
    valid = false;
  }

  if (!phone) {
    showFieldError("phone", "Vui lòng nhập số điện thoại");
    valid = false;
  } else if (phone.length !== 10) {
    showFieldError("phone", "Số điện thoại phải có 10 chữ số");
    valid = false;
  } else if (!VALID_PHONE_PREFIXES.includes(phone.substr(0, 3))) {
    showFieldError("phone", "Đầu số điện thoại không hợp lệ");
    valid = false;
  }

  if (!maDonHang) {
    showFieldError("ma_don_hang", "Vui lòng nhập mã đơn hàng");
    valid = false;
  }

  return valid;
}

/* --- Button Loading State --- */

function setButtonLoading(isLoading) {
  const btn = document.querySelector("#btn-active");
  if (!btn) return;
  const textEl = btn.querySelector(".bh-submit__text");
  const spinnerEl = btn.querySelector(".bh-submit__spinner");

  if (isLoading) {
    btn.classList.add("bh-submit--loading");
    btn.disabled = true;
    if (textEl) textEl.classList.add("bh-hidden");
    if (spinnerEl) spinnerEl.classList.remove("bh-hidden");
  } else {
    btn.classList.remove("bh-submit--loading");
    btn.disabled = false;
    if (textEl) textEl.classList.remove("bh-hidden");
    if (spinnerEl) spinnerEl.classList.add("bh-hidden");
  }
}

/* --- Submit Action --- */

function clickActive() {
  if (!validateForm()) return;

  const fullname = document.querySelector("#fullname").value.trim();
  const inputPhone = document.querySelector("#phone").value.trim();
  let maDonHang = document.querySelector("#ma_don_hang").value.trim().toUpperCase();

  if (!maDonHang.startsWith("SO")) {
    maDonHang = "SO" + maDonHang;
  }
  if (maDonHang.startsWith("S0")) {
    maDonHang = maDonHang.replace("S0", "SO");
  }

  setButtonLoading(true);

  fetch(`${window.theme.zuciani}/api/web/check_bao_hanh_tmdt`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      order_number: maDonHang,
      name: fullname,
      phone: inputPhone,
    }),
  })
    .then((response) => response.json())
    .then((dataActive) => {
      setButtonLoading(false);
      if (dataActive.status) {
        thongBaoThanhCong(dataActive.message);
      } else {
        thongBaoLoi(dataActive.message);
      }
    })
    .catch(() => {
      setButtonLoading(false);
      thongBaoLoi("Lỗi kết nối. Vui lòng thử lại sau.");
    });
}

/* --- Overlay / Modal --- */

function openOverlay(id) {
  document.body.classList.add("overflow-baohanh");
  const overlay = document.querySelector(`#${id}`);
  if (!overlay) return;
  overlay.classList.remove("bh-hidden");
  requestAnimationFrame(() => {
    overlay.classList.add("bh-overlay--visible");
  });
}

function closeOverlay(id) {
  const overlay = document.querySelector(`#${id}`);
  if (!overlay) return;
  overlay.classList.remove("bh-overlay--visible");
  setTimeout(() => {
    overlay.classList.add("bh-hidden");
    document.body.classList.remove("overflow-baohanh");
    if (id === "overlay-success") {
      document.querySelector("#fullname").value = "";
      document.querySelector("#phone").value = "";
      document.querySelector("#ma_don_hang").value = "";
      clearAllFieldErrors();
      removeBillFile();
      window.location.href = "/";
    }
  }, 300);
}

function clickHuongDan() {
  openOverlay("overlay-huongdan");
}

function thongBaoThanhCong(message) {
  openOverlay("overlay-success");
}

function thongBaoLoi(message) {
  const errorMsg = document.querySelector("#message-error");
  if (errorMsg) errorMsg.textContent = message;
  openOverlay("overlay-error");

  const errorModal = document.querySelector(".bh-modal--error");
  if (errorModal) {
    errorModal.classList.remove("bh-shake");
    requestAnimationFrame(() => {
      errorModal.classList.add("bh-shake");
    });
  }
}

function clickMuaSPKhac() {
  location.href = "/collections/san-pham-moi-dong-hai";
}

/* --- Tab Switching --- */

function switchInputMethod(method) {
  const cards = document.querySelectorAll(".bh-method-card");
  for (const card of cards) {
    const isActive = card.dataset.method === method;
    card.classList.toggle("bh-method-card--active", isActive);
    card.setAttribute("aria-checked", isActive ? "true" : "false");
  }

  const uploadZone = document.querySelector("#upload-zone");
  const manualFields = document.querySelector("#manual-fields");

  if (method === "upload") {
    if (uploadZone) {
      uploadZone.classList.remove("bh-section-hidden");
      uploadZone.classList.add("bh-section-visible");
    }
    if (manualFields) manualFields.classList.add("bh-hidden");
  } else {
    if (uploadZone) {
      uploadZone.classList.add("bh-section-hidden");
      uploadZone.classList.remove("bh-section-visible");
    }
    if (manualFields) manualFields.classList.remove("bh-hidden");
  }
}

/* --- Bill Upload --- */

function handleBillUpload(input) {
  const file = input.files[0];
  if (!file) return;

  if (!file.type.startsWith("image/")) {
    showUploadError("Vui lòng chọn file ảnh (JPG, PNG).");
    return;
  }
  if (file.size > 10 * 1024 * 1024) {
    showUploadError("Ảnh quá lớn. Vui lòng chọn ảnh dưới 10MB.");
    return;
  }

  showUploadPreview(file);
  showUploadLoading(true);
  setSubmitDisabled(true);

  const formData = new FormData();
  formData.append("file", file);

  fetch("https://n8n.giaydonghai.online/webhook/upload-bill", {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      if (!res.ok) throw new Error("Upload thất bại (" + res.status + ")");
      return res.json();
    })
    .then((data) => {
      showUploadLoading(false);
      setSubmitDisabled(false);

      if (!data || (!data.name && !data.phone && !data.order_code)) {
        showUploadError("Không thể nhận diện thông tin từ phiếu giao hàng. Vui lòng thử ảnh khác hoặc nhập tay.");
        return;
      }

      if (data.name) document.querySelector("#fullname").value = data.name;
      if (data.phone) document.querySelector("#phone").value = data.phone;
      if (data.order_code) document.querySelector("#ma_don_hang").value = data.order_code;

      document.querySelector("#upload-result").classList.remove("bh-hidden");
      document.querySelector("#upload-error").classList.add("bh-hidden");

      const manualFields = document.querySelector("#manual-fields");
      if (manualFields) manualFields.classList.remove("bh-hidden");
    })
    .catch((err) => {
      showUploadLoading(false);
      setSubmitDisabled(false);
      showUploadError("Lỗi khi xử lý ảnh: " + err.message + ". Vui lòng thử lại hoặc nhập tay.");
    });
}

function showUploadPreview(file) {
  const preview = document.querySelector("#upload-preview");
  const previewImg = document.querySelector("#upload-preview-img");
  const filename = document.querySelector("#upload-filename");
  const uploadArea = document.querySelector("#upload-area");

  const reader = new FileReader();
  reader.onload = (e) => {
    previewImg.src = e.target.result;
  };
  reader.readAsDataURL(file);

  filename.textContent = file.name;
  preview.classList.remove("bh-hidden");
  uploadArea.classList.add("bh-hidden");
}

function removeBillFile() {
  const billInput = document.querySelector("#bill-file");
  billInput.value = "";

  document.querySelector("#upload-preview").classList.add("bh-hidden");
  document.querySelector("#upload-preview-img").src = "";
  document.querySelector("#upload-area").classList.remove("bh-hidden");
  document.querySelector("#upload-result").classList.add("bh-hidden");
  document.querySelector("#upload-error").classList.add("bh-hidden");
  document.querySelector("#upload-loading").classList.add("bh-hidden");
}

function setSubmitDisabled(disabled) {
  const btn = document.querySelector("#btn-active");
  if (!btn) return;
  btn.disabled = disabled;
  btn.classList.toggle("bh-submit--disabled", disabled);
}

function showUploadLoading(show) {
  const loading = document.querySelector("#upload-loading");
  loading.classList.toggle("bh-hidden", !show);
  document.querySelector("#upload-result").classList.add("bh-hidden");
  document.querySelector("#upload-error").classList.add("bh-hidden");
}

function showUploadError(msg) {
  const errorEl = document.querySelector("#upload-error");
  const errorMsg = document.querySelector("#upload-error-msg");
  errorMsg.textContent = msg;
  errorEl.classList.remove("bh-hidden");
  document.querySelector("#upload-result").classList.add("bh-hidden");
}

